module.exports = __webpack_public_path__ + "img/eleven_en.1645ba14.png";